module.exports = __webpack_public_path__ + "static/media/Logo-Extra.99f5b644.png";